// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"containerStyles_wrapper__25Cwo","verticallyCentered":"containerStyles_verticallyCentered__3Uyrz","thin":"containerStyles_thin__2ewWO"};